import * as React from "react";
import { getGoogleMapsKey } from "../../pages/constants";
import MapComponent from "./MapComponent";

/**
 * Shows a google map. Allows to select a co-ordinate or show a set of markers
 * @param {*} props
 *    data: Set of co-ordinates to be shown as markers
 *    onClose: called when the dialog was closed without selecting any co-ordinate
 *    onSelect: called when the dialog was closed after selecting a co-ordinate
 *    defaultZoom: default zoom level in the map
 *    defaultCenter: default center in the map
 * @returns
 */
export default function CustomMapComponent(props) {
  console.log("CustomMapComponent, props:", props);
  return (
    <MapComponent
      markers={props.data}
      onClose={props.onClose}
      onSelect={props.onSelect}
      defaultZoom={props.defaultZoom}
      defaultCenter={props.defaultCenter}
    />
  );
}
